import { FC, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Button, Chip, Popover, Stack } from "@mui/material";
import { HexColorPicker } from "react-colorful";
import __ from "src/utils/Translations";
import getContrastTextColor from "src/utils/Company/Absences/getContrastTextColor";

interface IColorPickerProps {
  id: string;
  name: string;
  dataTestId?: string;
}

const ColorPicker: FC<IColorPickerProps> = ({ id, name, dataTestId }) => {
  const { control, watch } = useFormContext();
  const color = watch(name, "#aabbcc");
  const [anchorEl, setAnchorEl] = useState<
    HTMLButtonElement | HTMLInputElement | null
  >(null);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement | HTMLInputElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? "simple-popover" : undefined;
  const textColor = getContrastTextColor(color);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <Stack direction="row" alignItems="center">
            <input
              id={id}
              name={name}
              value={color}
              style={{
                display: "none",
              }}
            />
            <Chip
              label={__("Nazwa grupy")}
              color="primary"
              sx={{
                backgroundColor: color,
                color: textColor,
                "& .MuiChip-label": {
                  color: textColor,
                },
              }}
            />
            <Button
              aria-describedby={popoverId}
              variant="text"
              onClick={handleClick}
              sx={{
                ml: "1rem",
              }}
            >
              {__("Edytuj kolor")}
            </Button>
            <Popover
              id={popoverId}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              sx={{
                "& .MuiPopover-paper": {
                  bgcolor: "transparent",
                  boxShadow: "none",
                  overflow: "hidden",
                },
              }}
            >
              <HexColorPicker
                color={color}
                onChange={field.onChange}
                data-testid={dataTestId}
              />
            </Popover>
          </Stack>
        </>
      )}
    />
  );
};

export default ColorPicker;
